import { FC } from "react"

import { Box, CircularProgress } from "@mui/material"
import { useTranslation } from "react-i18next"

const LoadingIndicator: FC = () => {
  const { t } = useTranslation()

  return (
    <Box component="span" role="status" aria-live="polite">
      <CircularProgress aria-label={t("defaultTranslations.loading")} />
    </Box>
  )
}

export default LoadingIndicator
